export const SESSION_STORAGE_LANDING_EVENT_KEY = 'ss_landing_fired';
export const CURRENT_GUEST_DATA = 'current_guest_data';
export const CURRENT_GUEST_USER_ALREADY_EXISTS = 'current_guest_user_already_exists';
